import React from 'react'
import Campaign from './index'

const WebCampaigns = () => {
  return (
      <Campaign/>
  )
}

export default WebCampaigns
